// extracted by mini-css-extract-plugin
module.exports = {"volumeHolder":"LocalVideoControls_volumeHolder__348V2","timeHolder":"LocalVideoControls_timeHolder__2sJBf","sliderHolder":"LocalVideoControls_sliderHolder__2bZsS"};